import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class TravelHotelService {

    static gettravelHotel(item) {

        let api = `${API_BASE_URL}${API_PATHS.gettravelHotel}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
        if (item?.location) params.append("location", item.location);
        if (item?.name) params.append("name", item.name);
        if (item?.category) params.append("category", item.category);
       
        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api,item);
    }

    static addtravelHotel(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addtravelHotel}`;
        return axiosInstance
            .post(api, data)

    }

    static edittravelHotel(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.edittravelHotel}`;
        return axiosInstance
            .put(api, data)

    }

    static deletetravelHotel(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deletetravelHotel}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default TravelHotelService;
